import { setRecoil } from "recoil-nexus";
import { authenticationTokenState } from "atoms/authenticationTokenState.atom";

export const updateAuthenticationTokenState = (token) => {
  return new Promise(async (resolve) => {
    setRecoil(authenticationTokenState, token);
    localStorage.setItem("authenticationTokenState", token);
    resolve(true);
  });
};
